import { Component } from "react";
import $ from "jquery";
import ReactGA from "react-ga";

import Header from "./Components/Header";
import About from "./Components/About";
import Resume from "./Components/Resume";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";
import FloatingButton from "./Components/Floatingbutton";
import ChatPopup from "./Components/ChatPopup";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PortfolioPage from "./Pages/PortfolioPage";
import NotFound from "./Pages/NotFound";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { resumeData: {} };

    ReactGA.initialize("UA-110570651-1");
    ReactGA.pageview(window.location.pathname);
  }

  getResumeData() {
    $.ajax({
      url: "./resumeData.json",
      dataType: "json",
      cache: false,
      success: (data) => this.setState({ resumeData: data }),
      error: (xhr, status, err) => {
        console.log(err);
        alert(err);
      },
    });
  }

  componentDidMount() {
    this.getResumeData();
  }

  render() {
    const { resumeData } = this.state;

    return (
      <Router>
        <Routes>
          {/* صفحه اصلی */}
          <Route
            path="/"
            element={
              <>
                <Header data={resumeData.main} />
                <About data={resumeData.main} />
                <Resume data={resumeData.resume} />
                <Contact data={resumeData.main} />

                {/* دکمه شناور تماس و چت باکس در صفحه اصلی */}
                <FloatingButton />
                <ChatPopup />
              </>
            }
          />

          {/* صفحه Portfolio (Works) */}
          <Route path="/works" element={<PortfolioPage data={resumeData} />} />
          {/* صفحه 404 */}
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
        <Footer data={resumeData.main} />
      </Router>
    );
  }
}

export default App;
